import React from "react";
import { formatDate } from "../../../service/convert/date";
import { useNavigate } from "react-router-dom";
import { IBlog } from "../../../store/@types/blogs";
import { FaChevronRight } from "react-icons/fa";
import PreloadImage from "../../../components/ui/ImagePreloader/ImagePreloader";
import imageplaceholder from "../../../assets/images/imgplaceholders/placeholder.png";

type IBlogCard = {
  item: IBlog;
};

const BlogCard: React.FC<IBlogCard> = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/blog/${item?.id}`)}
      className="w-full  mx-auto overflow-hidden rounded-2xl shadow-md cursor-pointer bg-white transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px]"
    >
      <div className="h-48 overflow-hidden">
        <PreloadImage
          loading="lazy"
          imgSrc={item.feature_image}
          imgAlt={item?.title}
          imgClassName="object-cover object-center w-full h-64 transition-transform duration-300"
          placeholderSrc={imageplaceholder}
        />
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <span className="bg-primary-500 py-1 px-3 rounded-full text-[0.7rem] font-semibold tracking-widest text-primary-950">
            {item.category?.name || "Uncategorized"}
          </span>
          <div className="text-primary-900">
            {formatDate(new Date(item.created_at))}
          </div>
        </div>
        <h3 className="text-xl font-bold text-primary-900 mb-4 line-clamp-2 capitalize">
          {item.title}
        </h3>

        <p className="mt-4 text-gray-600 line-clamp-3">{item.excerpt}</p>
        <div className="mt-4 pt-4 border-t border-primary-200 flex justify-end">
          <a
            href={`/blog/${item.id}`}
            className="text-primary-600 hover:text-primary-700 font-medium flex items-center "
          >
            Read More <FaChevronRight className="h-4 w-4 ml-1" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
